import { Flex } from "@aircall/tractor";
import type { PropsWithChildren } from "react";

import type { PlaygroundSectionLayoutProps } from "./PlaygroundSectionLayout.decl";

export function PlaygroundSectionLayout({
  children,
  ...props
}: PropsWithChildren<PlaygroundSectionLayoutProps>) {
  return (
    <Flex gap="m" flexDirection="column" {...props}>
      {children}
    </Flex>
  );
}
